import { useEffect } from "react";

type CarouselTimeoutProps = {
  autoMove: number;
  tab: number;
  setTab: React.Dispatch<React.SetStateAction<number>>;
  contChildrens: number;
};

const CarouselMoveTimeout = ({
  autoMove,
  tab,
  setTab,
  contChildrens
}: CarouselTimeoutProps): void => {
  useEffect(() => {
    const itemTimeout = setInterval(() => {
      setTab(tab + 1 > contChildrens - 1 ? 0 : tab + 1);
    }, autoMove);
    return () => clearInterval(itemTimeout);
  }, [tab]);
};

export default CarouselMoveTimeout;
